// routes
import { paths } from 'src/routes/paths';
import { BrowserName } from '@/utils/browser';
import { toBoolean } from './utils';

// API
// ----------------------------------------------------------------------

// backend (NestJS) — set to https://im-api.numenai.tech in production.
// The previous is_test / TEST_VER toggles were Xano-specific and are gone.
export const HOST_API = process.env.NEXT_PUBLIC_HOST_API || '';

// Public-facing URLs shown in the UI.
export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || '';
export const introUrl = process.env.NEXT_PUBLIC_INTRO_URL || '';
export const whatsappNumber = process.env.NEXT_PUBLIC_WP_PHONE || '';

// google-map (still in use for the markets locator)
export const GOOGLE_MAP_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || '';

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.home;

// pwa
export const enabledPWAInstallerBanner = toBoolean(
  process.env.NEXT_PUBLIC_ENABLE_PWA_INSTALL,
  false
);

// Web Push — only the public VAPID key is needed in the browser to
// subscribe. The PRIVATE key lives in the backend (NotificationService),
// not here.
export const push_public_key = process.env.NEXT_PUBLIC_WEB_PUSH_PUBLIC_KEY || '';

export const BRANCH_NAME = process.env.NEXT_PUBLIC_BRANCH_NAME || '';

// cookies
export const cookies = {
  pwaInstallDismissed: {
    name: 'pwa_install_dissmissed',
  },
  showAppUpdated: {
    name: 'show_app_updated',
  },
  slideshowShown: {
    name: 'slideshow_shown',
  },
  landingShown: {
    name: 'landing_shown',
  },
  accessToken: {
    name: 'access_token',
  },
};

export const browserPWACompatility: Record<BrowserName, boolean> = {
  chrome: true,
  edge: true,
  firefox: false,
  opera: true,
  safari: false,
  samsung_internet: true,
  microsoft_edge_chromium: false,
  microsoft_internet_explorer: false,
  unknown: false,
};
